import type SVGProps from '~/components/icons/svg-props'

export function InformationIcon(props: SVGProps) {
  const { variant = 'outlined', width = '24', height = '24', ...rest } = props

  return variant === 'outlined' ? (
    <svg width={width} height={height} {...rest} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 17.3488C12.3853 17.3488 12.6977 17.0365 12.6977 16.6512V11.0698C12.6977 10.6845 12.3853 10.3721 12 10.3721C11.6147 10.3721 11.3023 10.6845 11.3023 11.0698V16.6512C11.3023 17.0365 11.6147 17.3488 12 17.3488Z"
        fill="currentColor"
      />
      <path
        d="M12 7.34884C12.5138 7.34884 12.9302 7.76532 12.9302 8.27907C12.9302 8.79282 12.5138 9.2093 12 9.2093C11.4862 9.2093 11.0698 8.79282 11.0698 8.27907C11.0698 7.76532 11.4862 7.34884 12 7.34884Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 3.39535C7.24778 3.39535 3.39535 7.24778 3.39535 12C3.39535 16.7522 7.24778 20.6047 12 20.6047C16.7522 20.6047 20.6047 16.7522 20.6047 12C20.6047 7.24778 16.7522 3.39535 12 3.39535Z"
        fill="currentColor"
      />
    </svg>
  ) : (
    <svg width={width} height={height} {...rest} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        fill="#9170b8"
      />

      <path
        d="M12 17.75c.4142 0 .75-.3358.75-.75v-6c0-.4142-.3358-.75-.75-.75s-.75.3358-.75.75v6c0 .4142.3358.75.75.75ZM12 7c.5523 0 1 .4477 1 1s-.4477 1-1 1-1-.4477-1-1 .4477-1 1-1Z"
        fill="white"
      />
    </svg>
  )
}
